import axios from 'axios';
import protobuf from 'protobufjs';
import protoJson from '@/proto/proto-json';

export const encode = (data: any, type = '') => {
  if (type === '') {
    return data;
  }
  console.log(type, data);
  const message = protoJson.lookupType(type);
  return message.encode(message.create(data)).finish();
};

export const decode = (data: number | number[], type = '') => {
  console.log(`decode type : ${type}`);
  if (type === '') {
    return data;
  }
  console.log(protoJson.lookupType(type).decode(protobuf.util.newBuffer(data)));
  return protoJson.lookupType(type).decode(protobuf.util.newBuffer(data));
};

const api = {
  get: (url: string, conf = {}) => {
    return axios
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
  put: (url: string, message = '', data = {}, conf = {}) => {
    return axios
      .put(url, message ? encode(data, message) : null, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
  post: (url: string, message: string, data = {}, conf = {}) => {
    return axios
      .post(url, encode(data, message), conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
  upload: (url: string, data: FormData) => {
    return axios
      .post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      });
  },
};

export default api;
